export default __webpack_public_path__ + "static/media/PIX FILL.013b612a.svg";